import type { SVGProps } from "react";

export function NaverMapIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 192 192" {...props}>
      <defs>
        <linearGradient
          id="naver-grad1"
          x1="25.723499"
          y1="29.355976"
          x2="131.06508"
          y2="134.69756"
          gradientTransform="matrix(1.161047,0,0,1.5899598,-29.330712,-34.429751)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#00f55d" />
          <stop offset="50%" stopColor="#00d021" />
          <stop offset="100%" stopColor="#03dd7e" />
        </linearGradient>
        <linearGradient
          id="naver-grad2"
          x1="35.365677"
          y1="300.85867"
          x2="89.057037"
          y2="300.85867"
          gradientTransform="matrix(1.9627702,0,0,0.71184145,-7.03162,-34.429751)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#4138f8" />
          <stop offset="100%" stopColor="#456bf6" />
        </linearGradient>
      </defs>
      <g transform="matrix(1.1256955,0,0,1.1256955,1.2714131,-12.054946)">
        <path
          d="M 167.76685,179.73393 H 62.38307 l 19.980555,-38.16268 0.03085,-0.057 h 85.372375 z"
          fill="url(#naver-grad2)"
        />
        <path
          d="M 9.6430919,105.4996 C -6.1719715,79.861256 -0.95870708,46.521907 21.928299,26.935141 c 22.888366,-19.5867659 56.631245,-19.5867659 79.519611,0 22.88836,19.586766 28.10162,52.924757 12.28656,78.564459 m -104.0913781,0 50.9872781,73.98704 c 0.116847,0.1712 0.192934,0.24729 0.364126,0.24729 h 1.192924 c 0.169833,0 0.366844,-0.24729 0.366844,-0.24729 L 113.73447,105.4996"
          fill="url(#naver-grad1)"
        />
        <path
          d="M 38.425422,52.01506 H 54.313855 L 69.209091,73.861316 V 52.013702 H 85.097523 V 94.714373 H 69.209091 L 54.313855,72.865401 V 94.713015 H 38.425422 Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
}
